import { IMemberClient } from "@wingspanhq/payments/dist/interfaces";
import { selectorClientCompany } from "./selectorClientCompany";
import { selectorClientEmail } from "./selectorClientEmail";
import { selectorClientName } from "./selectorClientName";

export const selectorEmployerName = (memberClient: IMemberClient) =>
  selectorClientCompany(memberClient) ||
  selectorClientName(memberClient) ||
  selectorClientEmail(memberClient);
